
import { useState } from "react";

export const useGenerateChargeback = () => {
  // Empty implementation since we've removed this feature
  return {
    handleGenerateReport: () => Promise.resolve(),
    isGeneratingChargeback: false,
    isDialogOpen: false,
    handleDialogOpenChange: () => {},
    handleOpenDisputeDialog: () => {}
  };
};
